import React from "react";
import { ManifestWorkProgress } from "./manifestProgress";
import "./manifestProgressCell.scss";

interface ManifestProgressCellProps {
  progress: ManifestWorkProgress;
}

const ManifestProgressCell: React.FC<ManifestProgressCellProps> = ({ progress }) => {
  const {
    completedStops,
    totalStops,
    completedPickups,
    totalPickups,
    combinedPercent,
    label,
  } = progress;

  const totalTasks = totalStops + totalPickups;
  const completedTasks = completedStops + completedPickups;
  const remaining = totalTasks - completedTasks;

  return (
    <div className="manifest-progress-cell">
      {/* Top row: percentage label + task count */}
      <div className="manifest-progress-cell__top-row">
        <span className="manifest-progress-cell__percent-label">
          {combinedPercent}%
        </span>
        <span className="manifest-progress-cell__task-count">
          {completedTasks} of {totalTasks} tasks
        </span>
      </div>

      {/* Progress bar */}
      <div
        className="manifest-progress-cell__bar-track"
        role="progressbar"
        aria-valuenow={combinedPercent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div
          className="manifest-progress-cell__bar-fill"
          style={{ width: `${combinedPercent}%` }}
        />
      </div>

      {/* Bottom row: Delivery · Pickup · rem */}
      <div className="manifest-progress-cell__bottom-row">
        {totalStops > 0 && (
          <span className="manifest-progress-cell__stat">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              className="manifest-progress-cell__dot"
              aria-hidden
            >
              <circle cx="5" cy="5" r="5" fill="#14870A" />
            </svg>
            <span className="manifest-progress-cell__stat-label">Delivery:</span>
            <span className="manifest-progress-cell__stat-value">
              {completedStops}/{totalStops}
            </span>
          </span>
        )}

        {totalPickups > 0 && (
          <span className="manifest-progress-cell__stat">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              className="manifest-progress-cell__dot"
              aria-hidden
            >
              <circle cx="5" cy="5" r="5" fill="#1A6FD4" />
            </svg>
            <span className="manifest-progress-cell__stat-label">Pickup:</span>
            <span className="manifest-progress-cell__stat-value">
              {completedPickups}/{totalPickups}
            </span>
          </span>
        )}

        {remaining > 0 && (
          <span className="manifest-progress-cell__rem">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              className="manifest-progress-cell__dot"
              aria-hidden
            >
              <circle cx="5" cy="5" r="5" fill="#4F5F72" fillOpacity="0.72" />
            </svg>
            <span className="manifest-progress-cell__stat-value">{remaining}</span>
            <span className="manifest-progress-cell__stat-label"> rem</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default ManifestProgressCell;
